// Copyright 2024, Christopher Banes and the Haze project contributors
// SPDX-License-Identifier: Apache-2.0

package dev.chrisbanes.haze

/**
 * Skiko always has blurring support (that we know of).
 */
internal actual fun isBlurEnabledByDefault(): Boolean = true
